export { default as DynamicComponent } from './DynamicComponent';
